import React from "react";
import { style } from "../style";


export default function Footer()
{
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full bg-black mt-auto mb-0">
            <div className="w-full md:w-[65rem] md:mx-auto flex flex-col md:flex-row justify-between items-center gap-2 py-6 px-4">
                <p className="text-white text-sm uppercase tracking-wide flex items-center gap-2">
                    <span className="w-2 h-2 bg-red-600 shrink-0"></span>
                    Developed by: <a className="text-white font-bold hover:text-red-600 transition-colors" href="https://moptec.net">MOPTEC</a>
                </p>
                <p className="text-neutral-400 text-xs uppercase tracking-wide">
                    &copy; {currentYear} MOPTEC
                </p>
            </div>
        </footer>
    );
}